import useInputError from "@Features/input/hooks/useInputError";
import {checkIfTicked} from "@Pages/contactForm/functions/checkFunctions";
import {useState} from "react";
import {useScroll} from "@Scroll/hooks/useScroll";
import ContactFormCheckboxType from "@Pages/contactForm/types/ContactFormCheckbox.type";

export default function useTermsAndConditionsCheckboxData(checkForErrors: boolean): ContactFormCheckboxType {
    const {elRef, executeScroll} = useScroll({})
    const [termsAccepted, setTermsAccepted] = useState(false)
    const {isError, showError} = useInputError({
        inputValue: termsAccepted,
        validate: checkIfTicked,
        checkFlag: checkForErrors,
    })
    const handleCheckboxInput = () => {
        setTermsAccepted(!termsAccepted)
    }

    return {
        value: termsAccepted,
        handleCheckboxInput,
        isError,
        showError,
        elRef,
        scrollToField: executeScroll,
    }
}